var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.routes.indexOf(this.$route.name) === -1
        ? _c("AppNavigation")
        : _vm._e(),
      _vm.routes.indexOf(this.$route.name) > -1 ? _c("AppFooter") : _vm._e(),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }